import { MapPin, Phone, Mail, Clock, Star, ArrowUpRight } from "lucide-react";
import { GOOGLE_PROFILE_URL, openGoogleProfile } from "@/lib/google";

export default function Contact() {
  return (
    <section id="contact" data-testid="contact-section" className="py-24 sm:py-32 bg-[#080808]/85 backdrop-blur-sm border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 grid lg:grid-cols-2 gap-12">
        <div>
          <div className="text-xs uppercase tracking-[0.25em] text-gold">05 — Contact</div>
          <h2 className="font-display font-black text-4xl sm:text-5xl lg:text-6xl mt-4 leading-[1.02]">
            Talk to us about your car.
          </h2>
          <p className="mt-6 text-neutral-400 max-w-md">
            For quotes, large vehicles, or special requests — call, text, or
            email. We reply within the same day.
          </p>

          <a
            href={GOOGLE_PROFILE_URL}
            target="_blank"
            rel="noopener noreferrer"
            onClick={openGoogleProfile}
            data-testid="contact-google-review"
            className="mt-8 inline-flex items-center gap-3 bg-[#0a0a0a] border border-white/15 hover:border-white/40 rounded-xl p-5 transition-colors group cursor-pointer"
          >
            <div className="flex -space-x-0.5">
              {Array.from({ length: 5 }).map((_, i) => (
                <Star key={i} className="w-4 h-4 fill-yellow-400 text-yellow-400" strokeWidth={1.5} />
              ))}
            </div>
            <div className="flex-1">
              <div className="text-[11px] uppercase tracking-[0.2em] text-neutral-500">Loved the detail?</div>
              <div className="font-display text-base mt-0.5">Leave us a Google review</div>
            </div>
            <ArrowUpRight className="w-4 h-4 text-neutral-400 group-hover:text-white transition-colors" strokeWidth={1.6} />
          </a>
        </div>
        <div className="grid sm:grid-cols-2 gap-4">
          {[
            { icon: Phone, label: "Call or text", value: "020 4172 1039", href: "tel:02041721039", testid: "contact-phone" },
            { icon: Mail, label: "Email", value: "abcardetails1@gmail.com", href: "mailto:abcardetails1@gmail.com", testid: "contact-email" },
            { icon: MapPin, label: "Find us on Google", value: "View on Google Maps", href: GOOGLE_PROFILE_URL, external: true, onClickHandler: openGoogleProfile, testid: "contact-location" },
            { icon: Clock, label: "Hours", value: "Tue · Thu · Sat · 9am – 3pm", testid: "contact-hours" },
          ].map((c) => (
            <a
              key={c.label}
              href={c.href || "#"}
              target={c.external ? "_blank" : undefined}
              rel={c.external ? "noopener noreferrer" : undefined}
              onClick={c.onClickHandler}
              data-testid={c.testid}
              className="block bg-[#0a0a0a] border border-white/10 hover:border-white/30 p-6 rounded-xl transition-colors cursor-pointer"
            >
              <c.icon className="w-5 h-5 text-white/70" strokeWidth={1.5} />
              <div className="mt-4 text-[11px] uppercase tracking-[0.2em] text-neutral-500">{c.label}</div>
              <div className="font-display text-lg mt-1">{c.value}</div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
